import React, { useEffect, useMemo, useState } from "react";
import useStore from "modules/dashboards/home/store";
import Customers from "modules/dashboards/customers/Customers";
import EngagementCard from "modules/dashboards/home/EngagementCard";
import moment from "moment";
import {
  ordersValueFn,
  repeatOrdersFn,
  inprogressOrdersFn,
  engagementSummaryFn,
} from "modules/utilities/utility";
import CardTabs from "modules/common/card-tabs/CardTabs";
import ProductivityDashboard from "modules/productivity_dashboard/ProductivityDashboard";
import secureLocalStorage from "react-secure-storage";

const Home = () => {
  const {
    data,
    assignedOrders,
    rawEngagements,
    fetchHomeData,
    fetchRevenue,
    fetchEngageStatus,
  } = useStore();
  const [sd, setSd] = useState(moment().startOf("d").toISOString());
  const [ed, setEd] = useState(moment().endOf("d").toISOString());
  const agentEmail = secureLocalStorage.getItem("email");

  useEffect(() => {
    fetchHomeData();
    fetchRevenue(sd, ed);
    fetchEngageStatus(sd, ed);
  }, []);

  useEffect(() => {}, [data, assignedOrders]);

  const repeatOrders = useMemo(() => {
    return repeatOrdersFn(assignedOrders);
  }, [assignedOrders]);

  const repeatOrdersCount = useMemo(() => {
    return repeatOrders.length;
  }, [repeatOrders]);

  const repeatOrdersValue = useMemo(() => {
    return ordersValueFn(repeatOrders);
  }, [repeatOrders]);

  const repeatOrdersAov = useMemo(() => {
    if (repeatOrdersValue <= 0 || repeatOrdersCount <= 0) return 0.0;
    return (repeatOrdersValue / repeatOrdersCount).toFixed(2);
  }, [repeatOrdersCount, repeatOrdersValue]);

  const repeatInProgressOrders = useMemo(() => {
    return inprogressOrdersFn(assignedOrders);
  }, [assignedOrders]);

  const engagementSummary = useMemo(() => {
    return engagementSummaryFn(rawEngagements);
  }, [rawEngagements]);

  const tabs = {
    home: (
      <>
        <EngagementCard
          data={data}
          orderCount={repeatOrdersCount}
          orderRevenue={repeatOrdersValue}
          orderAov={repeatOrdersAov}
          orderProgress={repeatInProgressOrders}
          rawEngagements={rawEngagements}
          summary={engagementSummary}
        />
        <Customers />
      </>
    ),
    "kpi dashboard": <ProductivityDashboard />,
  };

  return (
    <CardTabs components={tabs} />
    // <>
    //   <EngagementCard
    //     data={data}
    //     orderCount={repeatOrdersCount}
    //     orderRevenue={repeatOrdersValue}
    //     orderAov={repeatOrdersAov}
    //     orderProgress={repeatInProgressOrders}
    //     rawEngagements={rawEngagements}
    //     summary={engagementSummary}
    //   />
    //   <Customers />
    // </>
  );
};

export default Home;
